import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ICRMTasksWidgetModel, WidgetModel} from '../../model/widget.model';
import {TaskBoardModel} from '../../../../models/tasktable.model';

@Component({
    selector: 'app-board-select-settings',
    templateUrl: './board-select.settings.component.html',
    styleUrl: './board-select.settings.component.scss'
})
export class AppBoardSelectSettingsComponent implements OnInit {
    @Input() widget!: WidgetModel;
    @Input() multiChoice: boolean = true;
    @Input() optionDictKey: string = 'boards';
    public textFilterInput = new FormControl('');
    dashes: TaskBoardModel[] = []
    private subscription = new Subscription()

    ngOnInit(): void {
        this.dashes = this.widget.content.dashes
        this.subscription.add(
            this.textFilterInput.valueChanges.subscribe(filter =>
                filter ? this.dashes = this.widget.content.dashes.filter((el:any) => el.alias.toLocaleUpperCase().includes(filter?.toLocaleUpperCase())) : this.dashes = this.widget.content.dashes
            ))
    }

    changeSettings(target: string, widget: ICRMTasksWidgetModel, additionalKey?: string): void {
        let settingKey = additionalKey || this.optionDictKey
        if (this.multiChoice === false) {
            widget.options_dict[settingKey] = target
            return;
        }
        if (widget.options_dict[settingKey].includes(target)) {
            widget.options_dict[settingKey] = widget.options_dict[settingKey].filter((x:any) => x !== target);
            if (settingKey === 'task_board') {
                let typesToExclude = widget.content.dashes.find(board => board.alias === target)?.task_types.map(task => task.id)
                widget.options_dict['task_type'] = widget.options_dict['task_type'].filter((tasktype:any) => typesToExclude?.includes(tasktype) === false)
                console.log('widget.options_dict', structuredClone(widget.options_dict))

            }
        } else {
            widget.options_dict[settingKey].push(target);
            if (settingKey === 'task_board') {
                let typesToAdd = widget.content.dashes.find(el => el.alias === target)
                typesToAdd ? widget.options_dict['task_type'].push(...typesToAdd.task_types.map(task => task.id)) : null;
            }
        }
    }
}